const upSellDisplay = function () {
    const displayVarietiesModal = function (data, dataListNameOrigin) {
        let $modal = $('#modal-add-to-cart-other-flavours');
        let $result = $($.parseHTML(data));
        let hasFlavourTile = $result.find('.item-addToCart').length > 0;
        if (hasFlavourTile) {
            $modal.removeClass('modal-add-to-cart-other-flavours--empty');
        } else {
            $modal.addClass('modal-add-to-cart-other-flavours--empty');
        }

        let $replaceSection = $modal.find('.replaceMePlease');
        if ($replaceSection.length > 0) {
            $replaceSection.html('');
        }
        $replaceSection.html(data);

        if (data !== '') {
            $replaceSection.scrollTop(0);
        }
        bindFlavoursModalActionExceptions();
        $('#modal-add-to-cart-other-flavours-trigger').click();
        pushOtherFlavoursProductsViewToDatalayer(dataListNameOrigin);
        UAEvents.defineDocument('.modal-add-to-cart-other-flavours .tile-product', false);
        productTileSlick();
    }

    const displayUpsellSlide = function (data, productTile, dataListNameOrigin, isPDP, isPLP) {
        if (typeof isFlyerPageRequest === 'undefined') {
            isFlyerPageRequest = false;
        }
        let $upSellContainer = $("<div/>", {
            class: "product-upSell-container module-template"
        });
        let $parentContainer = productTile.closest('.layout--mini-template > div');

        if (isPDP) {
            displayUpSellPDP(data, $parentContainer, $upSellContainer);
        } else {
            if ($('.product-upSell-container.opening').length) {
                closeUpSellPanel();
            }
            $upSellContainer.addClass('slick-upSell');
            $upSellContainer.html(data);
            if(isPLP && !isFlyerPageRequest) {
                displayUpSellPLP(productTile, $upSellContainer);
                initUpSellSlick(productTile, true);
            } else if (isFlyerPageRequest) {
                displayUpSellFlyerGrid(productTile, $upSellContainer);
                initUpSellSlick(productTile, true);
            } else {
                displayUpSellHome(productTile, $parentContainer, $upSellContainer);
                initUpSellSlick(productTile, false);
            }
        }

        productTile.addClass('product-upSell-active');
        $upSellContainer.addClass('opening');
    }

    function initUpSellSlick (productTile, isPlp) {
        if (isPlp || isFlyerPageRequest) {
            productUpSellSlick();
        } else {
            productUpSellSlickHome();
        }

        upSellPanelControl();
        setTimeout(() => {
            $([document.documentElement, document.body]).animate({
                scrollTop: productTile.offset().top - 130
            }, 300);
        }, 200);
    }

    // FOR PDP //
    function displayUpSellPDP (data) {
        let $upSellContainer = $('.pdp--upsell-container');
        let $isSlickActive = $upSellContainer.find($('.slick-initialized'));
        $('.btn--pdp--displayFlavours').prop('disabled', true);
        $upSellContainer.empty();
        $upSellContainer.addClass('slick-pdp-upSell').html(data);

        productUpSellSlick();
        upSellPanelControl();
    }

    const windowWidth = window.innerWidth;
    function getOffsetRight(elm) {
        return windowWidth - (elm.getBoundingClientRect().left + elm.offsetWidth);
    }

    // FOR PlP //
    function displayUpSellPLP (productTile, upSellContainer) {
        let featuredTopFlyerDeals = document.querySelectorAll('.carousel-feature-product');
        let startOffsetRight = getOffsetRight(productTile[0]);
        let nextTileOffsetRight;
        let currentTile = productTile[0];
        let previousTile;

        if (currentTile.classList.contains('criteo-active-tile')) {
            currentTile = document.querySelector('.criteo-container');
            startOffsetRight = getOffsetRight(currentTile);
        }

        while (currentTile) {
            if (featuredTopFlyerDeals.length && featuredTopFlyerDeals[0].contains(currentTile)) {
                $(featuredTopFlyerDeals).append($(upSellContainer));
                break;
            }

            if (currentTile.classList.contains('cart-genius-placeholder')) {
                $(upSellContainer).insertBefore(currentTile);
                break;
            }

            if (currentTile.classList.contains('plp-gta-login')) {
                $(upSellContainer).insertBefore(currentTile);
                break;
            }

            if (currentTile) {
                previousTile = currentTile;
                currentTile = currentTile.nextElementSibling;
                if (!currentTile || windowWidth < 980) {
                    $(upSellContainer).insertAfter(previousTile);
                    break;
                }
            }

            nextTileOffsetRight = getOffsetRight(currentTile);

            if ((nextTileOffsetRight + 2) >= startOffsetRight) {
                $(upSellContainer).insertBefore(currentTile);
                break;
            }
        }
    }

    // FOR FLYER GRID VIEW
    function displayUpSellFlyerGrid (productTile, upSellContainer) {
        let featuredTopFlyerDeals = document.querySelectorAll('.carrousel-plp');
        let startOffsetRight = getOffsetRight(productTile[0]);
        let nextTileOffsetRight;
        let currentTile = productTile[0];
        let previousTile;

        while (currentTile) {
            if (featuredTopFlyerDeals.length && featuredTopFlyerDeals[0].contains(currentTile)) {
                $(upSellContainer).insertAfter(featuredTopFlyerDeals);
                break;
            }
            if (currentTile) {
                previousTile = currentTile;
                currentTile = currentTile.nextElementSibling;
                if (!currentTile || windowWidth < 980) {
                    $(upSellContainer).insertAfter(previousTile);
                    break;
                }
            }
            nextTileOffsetRight = getOffsetRight(currentTile);
            if ((nextTileOffsetRight + 2) >= startOffsetRight) {
                $(upSellContainer).insertBefore(currentTile);
                break;
            }
        }
    }


    // FOR HOMEPAGE //
    function displayUpSellHome (productTile, $parentContainer, $upSellContainer) {
        let $parentContainerFractionHalf = productTile.closest('.grid__half');
        let $parentContainerFractionThird = productTile.closest('.grid_third');
        let $parentContainerFractionQuarter = productTile.closest('.grid_quarter');
        let $isParentSlickMultiSlide = $parentContainer.find($('.slick-dotted')).length;
        let $isParentSlickComponent = $parentContainer.find($('.pt__carousel-advert-tile')).length;
        let $isParentSlimTileCarousel = $parentContainer.find($('.tiles--carousel-container')).length;
        $upSellContainer.addClass('homePageUpsell');

        //DEPENDING ON GRID TYPE AND SCREEN SIZE APPEND CROSS SELL CORRECTLY
        if ($parentContainerFractionHalf.length && (Revealizr.isMobileSize || Revealizr.isSmallTabletSize)) {
            $($upSellContainer).insertAfter($parentContainerFractionHalf);
        } else if ($parentContainerFractionThird.length) {
            if (Revealizr.isMobileSize) {
                $($upSellContainer).insertAfter($parentContainerFractionThird);
            } else if (Revealizr.isSmallTabletSize) {
                let tileIndex = $parentContainerFractionThird.index();
                let $tileParent = $parentContainerFractionThird.parent();
                let tileSiblingsLength = $tileParent.children().length - 1;
                if (+tileSiblingsLength === +tileIndex) {
                    $($upSellContainer).insertAfter($parentContainer);
                } else {
                    let tileWidth = $parentContainerFractionThird.width();
                    let screenWidth = $(window).width();
                    let tileLeftOffset = $parentContainerFractionThird.offset().left;
                    if (tileWidth < (screenWidth / 2)) {
                        if (+tileIndex === 0 || tileLeftOffset < (screenWidth / 2)) {
                            $($upSellContainer).insertAfter($parentContainerFractionThird.next());
                        } else if (tileLeftOffset > (screenWidth / 2)) {
                            $($upSellContainer).insertAfter($parentContainerFractionThird);
                        }
                    } else if (tileWidth > (screenWidth / 2)) {
                        $($upSellContainer).insertAfter($parentContainerFractionThird);
                    }
                }
            } else {
                $($upSellContainer).insertAfter($parentContainer);
            }
        } else if ($parentContainerFractionQuarter.length) {
            getProductTileIndex($parentContainerFractionQuarter);
            if (Revealizr.isMobileSize) {
                $($upSellContainer).insertAfter($parentContainerFractionQuarter);
            } else if (Revealizr.isSmallTabletSize) {
                let tileIndex = $parentContainerFractionQuarter.index();
                let $tileParent = $parentContainerFractionQuarter.parent();
                let tileSiblingsLength = $tileParent.children().length - 1;
                let $mixedTileWidth = $tileParent.find('.grid__half').length;
                if ($mixedTileWidth) {
                    let tileWidth = $parentContainerFractionQuarter.width();
                    let screenWidth = $(window).width();
                    let tileLeftOffset = $parentContainerFractionQuarter.offset().left;
                    let isNextTileOrderNegative = $parentContainerFractionQuarter.next().hasClass('order--minus');
                    if (tileWidth < (screenWidth / 2)) {
                        if (tileLeftOffset < (screenWidth / 2)) {
                            if (isNextTileOrderNegative) {
                                $($upSellContainer).insertAfter($parentContainerFractionQuarter.next().next());
                            } else {
                                $($upSellContainer).insertAfter($parentContainerFractionQuarter.next());
                            }
                        } else if (tileLeftOffset > (screenWidth / 2)) {
                            $($upSellContainer).insertAfter($parentContainerFractionQuarter);
                        }
                    } else if (tileWidth > (screenWidth / 2)) {
                        $($upSellContainer).insertAfter($parentContainerFractionQuarter);
                    }

                } else if (+tileSiblingsLength === +tileIndex) {
                    $($upSellContainer).insertAfter($parentContainer);
                } else {
                    if ((+tileIndex + 1) % 2 === 0) {
                        $($upSellContainer).insertAfter($parentContainerFractionQuarter);
                    } else {
                        $($upSellContainer).insertAfter($parentContainerFractionQuarter.next());
                    }
                }
            } else {
                $($upSellContainer).insertAfter($parentContainer);
            }
        } else {
            $($upSellContainer).insertAfter($parentContainer);
        }

        if ($isParentSlimTileCarousel) {
            $upSellContainer.addClass('upSell-container-adjust-pos-a');
        } else if ($isParentSlickMultiSlide) {
            $upSellContainer.addClass('upSell-container-adjust-pos-b');
        } else if ($isParentSlickComponent) {
            $upSellContainer.addClass('upSell-container-adjust-pos-c');
        }
    }

    return {
        displayVarietiesModal: displayVarietiesModal,
        displayUpsellSlide: displayUpsellSlide,
    }
}();

function getProductTileIndex(productTileGridParent) {
    return productTileGridParent.index();
}

function closeUpSellPanel() {
    $('.product-upSell-active').removeClass('product-upSell-active');
    $('.product-upSell-container.opening').addClass('closing').removeClass('opening');
    $('.displayVarietiesActive').removeClass('displayVarietiesActive');
    let $otherVarietiesPDP = $('.btn--pdp--displayFlavours');
    if ($otherVarietiesPDP.length) {
        $otherVarietiesPDP.prop('disabled', false);
    }
    setTimeout(() => {
        $('.product-upSell-container.closing').remove();
    }, 400);
}

function upSellPanelControl() {
    $('.close-upSell-panel').on('click', function () {
        closeUpSellPanel();
    });
}

function pushOtherFlavoursProductsViewToDatalayer(dataListName) {
    if (typeof dataListName !== 'undefined') {
        var $modal = $('#modal-add-to-cart-other-flavours');
        $modal.find('.productsSlider').attr('data-list-name', dataListName);
    }
}

let initScreenWidth = window.innerWidth;
const tabletWindow = 975;
const desktopWindow = 1200;
const desktop1kWindow = 1900;
const desktop2kWindow = 2140;

const onResizeDebouncedUpSell = _.debounce(() => {
    if ($('.product-upSell-container.opening').length) {
        const windowWidth = window.innerWidth;

        if (initScreenWidth < tabletWindow && windowWidth >= tabletWindow) {
            closeUpSellPanel();
        } else if (initScreenWidth < desktopWindow && (windowWidth < tabletWindow || windowWidth >= desktopWindow)) {
            closeUpSellPanel();
        } else if (initScreenWidth < desktop1kWindow && (windowWidth < desktopWindow || windowWidth >= desktop1kWindow)) {
            closeUpSellPanel();
        } else if ((initScreenWidth < desktop2kWindow && initScreenWidth >= desktop1kWindow) && windowWidth < desktop1kWindow) {
            closeUpSellPanel();
        }

        initScreenWidth = windowWidth;
    }
}, 100);

if (!TINK.isIosMobile && !TINK.isMobile) {
    window.addEventListener("resize", onResizeDebouncedUpSell);
}